export default __webpack_public_path__ + "static/media/alerta.ec45d564.svg";